import React, { useState } from 'react';
import moment from 'moment';

import {
  Paper, TextField, Button, Grid, Modal,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { insertOrUpdateSpeechSession } from '../api/axios';
import { COUNTRY_CODES, WEEK_DAYS_REVERSE_MAPPINGS } from '../utils/constants';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((theme) => {
  return {
    box: {
      padding: 8,
      width: 60,
      height: 45,
      display: 'flex',
      borderRadius: 8,
      background: 'white',
      color: '#555',
      justifyContent: 'center',
      textAlign: 'center',
      fontWeight: 600,
      margin: 5,
      '&:hover': {
        background: theme.orangeColor,
        color: '#fff',
      },
      boxShadow: theme.boxShadow,
    },
    activeBox: {
      padding: 8,
      width: 60,
      height: 45,
      display: 'flex',
      borderRadius: 8,
      background: theme.orangeColor,
      color: '#fff',
      justifyContent: 'center',
      fontWeight: 600,
      margin: 5,
      '&:hover': {
        background: theme.orangeColor,
        color: '#fff',
      },
      boxShadow: theme.boxShadow,
    },
  };
});

function SpeechTherapistForm(props) {
  const { data } = props;
  const classes = useStyles();

  const getInitialState = (initialData = {}) => {
    return {
      _id: initialData._id,
      countries: initialData.countries || [],
      durationMinutes: initialData.durationMinutes || '',
      meeting_url: initialData.meeting_url || '',
      title: initialData.title || '',
      therapist_image_url: initialData.therapist_image_url || '',
      therapist_name: initialData.therapist_name || '',
      time: (initialData.time && new Date(initialData.time)) || new Date(),
      isActive: initialData.isActive || true,
      isPaid: initialData.isPaid || false,
      weekDays: (initialData.weekDays && initialData.weekDays.map((date) => { return new Date(date).getDay(); })) || [],
      isRepeat: initialData.isRepeat || true,
    };
  };

  const [state, setState] = useState(getInitialState());

  const handleDateChange = (date) => {
    const newDate = new Date(date);
    newDate.setSeconds(0);
    setState({ ...state, time: newDate });
  };

  const handleChange = (e) => { return setState({ ...state, [e.target.name]: e.target.value }); };

  const getWeekDays = () => {
    const selectedDays = [];
    const DATE_FORMAT = 'DD/MM/YYYY';
    const TIME_FORMAT = 'HH:mm';
    const startWeekDate = moment(new Date(state.time)).startOf('week').toDate();
    const startTimeString = moment(startWeekDate).format(DATE_FORMAT);
    let thisWeekStartTime = moment(startTimeString, `${DATE_FORMAT} ${TIME_FORMAT}`).toDate();
    const hours = new Date(state.time).getHours();
    const mins = new Date(state.time).getMinutes();
    thisWeekStartTime = moment(thisWeekStartTime).add(hours, 'hours').toDate();
    thisWeekStartTime = moment(thisWeekStartTime).add(mins, 'minutes').toDate();
    const pushData = (startTime) => {
      selectedDays.push(startTime);
    };
    state.weekDays.forEach((dayIndex) => {
      const startTime = moment(thisWeekStartTime).add(dayIndex, 'days').toDate();
      pushData(startTime);
    });
    return selectedDays;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const weekDays = getWeekDays();
    const isRepeat = weekDays.length !== 0;
    insertOrUpdateSpeechSession({ ...state, weekDays, isRepeat })
      .then(() => {
        setState(getInitialState());
        props.refreshPage();
        props.onClose();
      });
  };

  const handleChangeMultiple = (event) => {
    let codes = event.target.value;
    if (codes.includes('All') && state.countries.length === Object.values(COUNTRY_CODES).length) {
      codes = [];
    } else if (codes.includes('All')) codes = Object.values(COUNTRY_CODES);
    setState((prevState) => {
      return { ...prevState, countries: codes };
    });
  };

  const handleCheckbok = (event) => {
    const isChecked = event.target.checked;
    setState((prevData) => {
      let days = prevData.days;
      if (!isChecked) days = [];
      return { ...state, days, isRepeat: isChecked };
    });
  };

  const addOrRemoveDay = (dayIndex) => {
    const index = state.weekDays.indexOf(dayIndex);
    if (index === -1) setState({ ...state, weekDays: [...state.weekDays, dayIndex] });
    else {
      const days = state.weekDays;
      days.splice(index, 1);
      setState({ ...state, weekDays: [...days] });
    }
  };

  React.useEffect(() => {
    if (data) setState(getInitialState(data));
  }, [data]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Modal
        open={props.open}
        style={{ paddingTop: '50px' }}
        onClose={props.onClose}
      >
        <Paper
          outline="none"
          style={{
            width: '80%',
            padding: 20,
            margin: 'auto',
          }}
        >
          <h3>
            Add Speech Therapist sessions
          </h3>
          <form
            className="form"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-mutiple-checkbox-label">Select Countries</InputLabel>
                  <Select
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    multiple
                    value={state.countries}
                    onChange={handleChangeMultiple}
                    input={<Input />}
                    renderValue={(selected) => { return selected.join(', '); }}
                    MenuProps={MenuProps}
                  >
                    <MenuItem value="All">
                      <Checkbox checked={state.countries.length === Object.values(COUNTRY_CODES).length} />
                      <ListItemText primary="All" />
                    </MenuItem>
                    {Object.values(COUNTRY_CODES).map((name, index) => {
                      return (
                        <MenuItem key={name} value={name}>
                          <Checkbox checked={state.countries.indexOf(name) > -1} />
                          <ListItemText primary={`${Object.keys(COUNTRY_CODES)[index]} (${name})`} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="durationMinutes"
                  label="Duration Minutes"
                  type="number"
                  fullWidth
                  required
                  variant="outlined"
                  value={state.durationMinutes}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="title"
                  label="Title"
                  fullWidth
                  required
                  variant="outlined"
                  value={state.title}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="meeting_url"
                  label="Meeting URL"
                  fullWidth
                  required
                  variant="outlined"
                  value={state.meeting_url}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="therapist_image_url"
                  label="Therapist Image URL"
                  fullWidth
                  required
                  variant="outlined"
                  value={state.therapist_image_url}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="therapist_name"
                  label="Therapist Name"
                  fullWidth
                  required
                  variant="outlined"
                  value={state.therapist_name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item container spacing={3} md={6} xs={12}>
                <Grid item>
                  <p style={{ padding: '0px', margin: '0px' }}>Time</p>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Date"
                    format="MM/dd/yyyy"
                    value={state.time}
                    variant="outlined"
                    fullWidth
                    required
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Grid>
                <Grid item>
                  <br />
                  <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    label="Time"
                    value={state.time}
                    variant="outlined"
                    fullWidth
                    required
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                    }}
                  />
                </Grid>
              </Grid>
              <FormControl style={{ marginTop: '15px', width: '50%', padding: 15 }}>
                <InputLabel id="simple-select-active-label">Is Active?</InputLabel>
                <Select
                  labelId="simple-select-active-label"
                  id="simple-select-active"
                  value={state.isActive}
                  name="isActive"
                  onChange={(e) => { return handleChange(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value>
                    Yes
                  </MenuItem>
                  <MenuItem value={false}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{ marginTop: '15px', width: '50%', padding: 15 }}>
                <InputLabel id="simple-select-active-label">Is Paid?</InputLabel>
                <Select
                  labelId="simple-select-active-label"
                  id="simple-select-active"
                  value={state.isPaid}
                  name="isPaid"
                  onChange={(e) => { return handleChange(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value>
                    Yes
                  </MenuItem>
                  <MenuItem value={false}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
              <Grid container>
                <Grid item container xs={12} justify="flex-start">
                  <FormControlLabel
                    control={(
                      <Checkbox
                        checked={state.isRepeat}
                        onChange={handleCheckbok}
                        name="isRepeat"
                        color="secondary"
                      />
                )}
                    label="Is Repeat?"
                  />
                </Grid>
                <Grid item container xs={12} justify="center">
                  {
                  state.isRepeat && Object.values(WEEK_DAYS_REVERSE_MAPPINGS).map((day, index) => {
                    return (
                      <div key={day}>
                        <Button
                          variant="contained"
                          className={state.weekDays.indexOf(index) !== -1 ? classes.activeBox : classes.box}
                          onClick={() => { addOrRemoveDay(index); }}
                        >
                          {day}
                        </Button>
                      </div>
                    );
                  })
              }
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="center">
              <Button
                variant="contained"
                style={{ marginTop: '60px', fontWeight: 'bold' }}
                type="submit"
                color="primary"
              >
                {state._id ? 'Update' : 'Add'}
              </Button>
            </Grid>
          </form>
        </Paper>
      </Modal>
    </MuiPickersUtilsProvider>
  );
}

export default SpeechTherapistForm;
